import { Money } from '@grammarly/http-clients-subscription'
import { FacadeService, ProPlan } from '../facade'

export interface SubscriptionProPlan {
  readonly monthlyPrice: number
  readonly monthlyPricePerMonth: number
  readonly currency: string
  readonly percentageOfSavings: number
}

export interface SubscriptionService {
  readonly proPlan: SubscriptionProPlan
}

export class SubscriptionServiceImpl implements SubscriptionService {
  readonly proPlan: SubscriptionProPlan

  constructor(facade: FacadeService) {
    this.proPlan = this.getProPlan(facade.get().proPlans || [])
  }

  private getProPlan(proPlans: ProPlan[]): SubscriptionProPlan {
    const priceFallback = 12
    const pricePerMonthFallback = 30
    const { value: annualPrice, currency } = this.getPriceForPeriod(proPlans, 12, priceFallback * 12)
    const monthlyPricePerMonth = this.getPriceForPeriod(proPlans, 1, pricePerMonthFallback).value
    const monthlyPrice = this.calculateMonthlyPrice(annualPrice)
    const percentageOfSavings = this.calculateSavings(annualPrice, monthlyPricePerMonth)

    return {
      monthlyPrice,
      monthlyPricePerMonth,
      currency,
      percentageOfSavings,
    }
  }

  private getPriceForPeriod(proPlans: ProPlan[], periodMonths: 1 | 12, fallbackValue: number): Money {
    return (
      proPlans.find((plan) => plan.periodMonths === periodMonths)?.priceMoney ?? {
        currency: 'USD',
        value: fallbackValue,
      }
    )
  }

  private calculateMonthlyPrice(annualPrice: number): number {
    return Math.round(annualPrice / 12)
  }

  private calculateSavings(annualPrice: number, monthlyPricePerMonth: number): number {
    const yearlyPricePerMonth = monthlyPricePerMonth * 12
    const savingsInPercent = (1 - annualPrice / yearlyPricePerMonth) * 100
    return Math.round(savingsInPercent / 5) * 5
  }
}
